import { render, staticRenderFns } from "./CategoriesDelete.vue?vue&type=template&id=95df3e0a&scoped=true&"
import script from "./CategoriesDelete.vue?vue&type=script&lang=js&"
export * from "./CategoriesDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95df3e0a",
  null
  
)

export default component.exports